import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Table from "../../react-components/table";
import Heading from "../../elements/heading";
import IconLinkEle from "../../elements/icon-link";
import api from "../../utils/api";

export default class OpenPositionsTeamtailor extends Component {
  constructor(props, context) {
    super(props, context);
    const { fields } = this.props;
    const { size, CTA } = fields;
    const cta = CTA.length ? CTA[0] : undefined;
    if (cta) cta.fields.link.value.href = undefined;
    let IconLink = cta
      ? cta.fields
      : {
          link: {
            value: { text: fields.loadMoreText.value }
          }
        };
    IconLink.callback = () => this.loadMore();
    this.state = {
      meta: { "record-count": Number((size && size.value) || 10000) },
      tableData: {
        fields: {
          headings: [],
          rows: [],
          firstColumnIsLeadColumn: { value: true },
          sortIsEnabled: { value: true },
          noRowsBody: { value: null }
        }
      },
      currentPage: 1,
      totalItemsCount: 10,
      apistate: true,
      pageSize: Number((size && size.value) || 10000),
      IconLink: IconLink
    };
  }

  loadMore = event => {
    this.getData();
  };
  async getData() {
    let model = this.props.fields ? this.props.fields : {};
    if (!this.state.apistate) {
      return false;
    }
    this.setState({
      apistate: false
    });
    // let recordCount = 0;
    api.teamtailor
      .jobs({
        "page[number]": this.state.currentPage,
        "page[size]": this.state.pageSize
      })
      .then(res => {
        let tableData = this.state.tableData;
        let columnHeadings = this.props.fields.columnHeadings?.value ? this.props.fields.columnHeadings.value.split(/\r?\n/) : undefined;
        let rows = tableData.fields.rows;
        let IconLink = this.state.IconLink;
        let headerArr = [];
        this.recordCount = res.meta["record-count"];
        const items = res && Array.isArray(res.data) ? res.data : [];
        items.forEach((item, jobIndex) => {
          let items = [];
          const locationId = item.relationships.locations.data[0]?.id,
            departmentId = item.relationships.department.data?.id;
          items.push({ key: "link", value: item.links["careersite-job-url"] });
          items.push({ key: "title", value: item.attributes.title });
          items.push({
            key: "city",
            value: res.included.find(i => i.id === locationId)?.attributes.name
          });
          items.push({
            key: "department",
            value: res.included.find(i => i.id === departmentId)?.attributes.name
          });
          let rowItems = [],
            colIndex = 0;
          items.forEach(item => {
            if (item.key !== "link") {
              //Headings
              if (jobIndex === 0) {
                const objKey = {
                  fields: {
                    text: {
                      value: columnHeadings.length ? columnHeadings[colIndex] : item.key
                    }
                  }
                };
                headerArr.push(objKey);
                colIndex++;
              }
              const objValue = {
                fields: {
                  text: {
                    value: item.value
                  }
                }
              };
              rowItems.push(objValue);
            } else {
              rows.push({
                fields: {
                  link: {
                    value: {
                      href: item.value
                    }
                  }
                }
              });
            }
          });
          rows[rows.length - 1].fields.items = rowItems;
        });
        tableData.fields.headings = [...headerArr];
        if (items.length <= this.state.pageSize) {
          if (model.CTA.length) {
            IconLink.isDisabled = {
              value: items.length === 0 || items.length < this.state.pageSize
            };
          }
          if (!tableData.fields.rows.length) {
            tableData.fields.noRowsBody.value = <p>{this.props.fields.noJobsMessage.value}</p>;
          }
        }
        this.setState({
          meta: res.meta,
          currentPage: this.state.currentPage + 1,
          tableData: tableData,
          IconLink: IconLink,
          totalItemsCount: items.length,
          apistate: true
        });
      })
      .catch(res => console.log(res));
  }
  componentDidMount(props) {
    this.getData();
  }

  render() {
    if (!this.props.fields) return null;
    let model = this.props.fields ? this.props.fields : {};
    const { headingBody, headingType, body, CTA } = model;
    const { tableData, totalItemsCount, pageSize, IconLink } = this.state;
    const morePrimaryButtonClasses = classNames("more-jobs", {
      disabled: tableData.fields.rows.length >= this.recordCount
    });

    return (
      <div className={"open-positions-teamtailor grid"} datasourceid={this.props.rendering.dataSource}>
        {headingBody && (
          <Heading
            className={"title show-on-scroll"}
            {...{
              type: headingType,
              html: headingBody
            }}
          />
        )}

        {body && body.value && <RichText tag="div" className={"body-text"} field={body} />}

        <div className={"table-container"}>{tableData && <Table {...tableData} />}</div>
        {tableData.fields.rows.length > 0 && CTA.length && tableData.fields.rows.length < this.state.meta["record-count"] && <IconLinkEle className={morePrimaryButtonClasses} {...IconLink} />}
      </div>
    );
  }
}
